module.exports = __webpack_public_path__ + "static/media/svg9.babc1b3d.svg";